// StockStatusBadge.jsx
// Stock status indicator: OK / Low / At Risk / Short

import React from 'react';

const STATUS_COLORS = {
    ok: { bg: 'var(--color-success-light)', text: 'var(--color-success-dark)' },
    low: { bg: 'var(--color-warning-light)', text: 'var(--color-warning-dark)' },
    'at-risk': { bg: 'var(--color-warning-light)', text: 'var(--color-danger-dark)' },
    short: { bg: 'var(--color-danger-light)', text: 'var(--color-danger-dark)' }
};

const STATUS_LABELS = {
    ok: 'OK',
    low: 'Low',
    'at-risk': 'At Risk',
    short: 'Short'
};

/**
 * Compute stock status from projected qty and reorder point
 */
export function getStockStatus(projected, reorderPoint) {
    if (projected <= 0) return 'short';
    if (projected < reorderPoint * 0.5) return 'at-risk';
    if (projected < reorderPoint) return 'low';
    return 'ok';
}

const StockStatusBadge = ({ status }) => {
    const colors = STATUS_COLORS[status] || STATUS_COLORS.ok;
    const label = STATUS_LABELS[status] || status;
    return (
        <span style={{
            display: 'inline-block',
            padding: '3px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: 500,
            backgroundColor: colors.bg,
            color: colors.text
        }}>
            {label}
        </span>
    );
};

export default StockStatusBadge;
